import React from 'react';

import SvgContainer from '../SvgContainer';

const Star = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9078_100933)">
                <path d="M7.67729 13.7709C7.87424 13.6448 8.12576 13.6448 8.32271 13.7709L11.5024 15.8071C12.4069 16.3862 13.5548 15.5751 13.3229 14.5207L12.4468 10.536C12.4001 10.3239 12.4696 10.1029 12.6288 9.95656L15.6057 7.22043C16.3797 6.50905 15.9452 5.2097 14.9018 5.11579L11.0727 4.77112C10.8474 4.75084 10.6525 4.60498 10.568 4.39352L9.11647 0.760001C8.71166 -0.253334 7.28834 -0.253333 6.88353 0.760002L5.43201 4.39352C5.34754 4.60498 5.15257 4.75084 4.92731 4.77112L1.09818 5.11579C0.0548482 5.2097 -0.379731 6.50905 0.39426 7.22043L3.3712 9.95656C3.53044 10.1029 3.59987 10.3239 3.55325 10.536L2.67708 14.5207C2.44524 15.5751 3.59315 16.3862 4.49756 15.8071L7.67729 13.7709Z" />
            </g>
            <defs>
                <clipPath id="clip0_9078_100933">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Star;
